import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { createYotpoInfo } from '@/entities/(integration)/yotpo';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import type { Schema } from '@/shared/api/generated';

const YotpoRedirect = () => {
  const [, setRedirect] = useCrossWindowState<Schema<'YotpoInfo'> | null>(
    'yotpo-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const accountID = searchParams.get('app_key');

    if (code && state && accountID) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        try {
          const data = await createYotpoInfo({
            workspace_id: workspaceAlias,
            account_id: accountID,
            code: code,
            redirect_uri: `${window.location.origin}/yotpo`,
          });

          if (data) {
            setRedirect(data);
            window.close();
          } else {
            navigate('/500', { replace: true });
          }
        } catch {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting Yotpo...</LoadingLayout>;
};

export default YotpoRedirect;
